import {injectable} from 'inversify';

import type {CardModel} from './Card.model';

import {BaseController} from '../../../core/domain/Base/Base.controller';

@injectable()
export class CardController extends BaseController<CardModel> {
  constructor() {
    super();
  }
}
